import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@portals/core';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';

@Component({
	selector: 'portals-intl-phonenumber',
	templateUrl: './intl-phonenumber.component.html',
	styleUrls: ['./intl-phonenumber.component.scss'],
})
export class IntlPhonenumberComponent extends BaseComponent {
	number!: any;
	separateDialCode = true;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
	PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];

	@Input() placeholder!: string;
	@Output() phoneNumber = new EventEmitter<string>();

	constructor(private formBuilder: FormBuilder) {
		super();
	}

	emitNumber() {
		this.phoneNumber.emit(this.number?.internationalNumber);
	}
}
